/* LK | Meterware-Konfigurator – Länge, Staffel, Lichtaustritt, Live-Bild, Galerie, Warenkorb */
(() => {
  if (customElements.get('lk-meterware')) return;
  const LIGHT = { '2700 K': '#ffcf91', '3000 K': '#ffdcab', '4000 K': '#fff1df' };
  const SOFT = [0, .0165, .0585, .1173, .1859, .2593, .3337, .4066, .4761, .5411, .6009, .6552, .7039, .7473, .7856, .819, .8481, .8732, .8947, .9131, .9287, .9418, .9528, .962, .9696, .9759, .981, .9852, .9886, .9914, .9935, .9953, .9966, .9977, .9985, .9991, 1];
  const ease = (p) => { const x = p * (SOFT.length - 1), i = Math.min(Math.floor(x), SOFT.length - 2); return SOFT[i] + (SOFT[i + 1] - SOFT[i]) * (x - i); };

  class LkMeterware extends HTMLElement {
    connectedCallback() {
      const dataNode = this.querySelector('[data-lk-mw-data]');
      if (!dataNode || this.dataset.lkReady) return;
      try { this.data = JSON.parse(dataNode.textContent); } catch (e) { return; }
      this.dataset.lkReady = 'true';
      this.page = this.closest('.lk-mw-page') || this;
      this.$ = (s) => this.querySelector(s);
      this.range = this.$('[data-lk-mw-range]');
      this.number = this.$('[data-lk-mw-number]');
      this.form = this.$('[data-lk-mw-form]');
      this.totalNode = this.$('[data-lk-mw-total]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: this.data.currency || 'EUR' });
      this.state = { surface: this.checked('surface'), light: this.checked('light'), dim: this.checked('dim'), dist: this.checked('dist'), length: this.clamp(Number(this.range?.value)) };
      this.displayCents = 0;
      this.abort = new AbortController();
      const o = { signal: this.abort.signal };

      this.addEventListener('change', (e) => {
        const input = e.target.closest?.('[data-lk-mw-input]');
        if (!input || !input.checked) return;
        this.state[input.dataset.lkMwInput] = input.value;
        this.update();
      }, o);
      this.range?.addEventListener('input', () => this.setLength(Number(this.range.value), 'range'), o);
      this.number?.addEventListener('input', () => {
        const v = Number(this.number.value);
        if (v >= this.data.min && v <= this.data.max) this.setLength(v, 'number', true);
      }, o);
      this.number?.addEventListener('change', () => this.commitNumber(), o);
      this.number?.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); this.commitNumber(); } }, o);
      this.addEventListener('click', (e) => {
        const step = e.target.closest?.('[data-lk-mw-step]');
        if (step) {
          const d = Number(step.dataset.lkMwStep), s = Math.abs(d), b = this.state.length;
          this.setLength(d > 0 ? Math.floor(b / s) * s + s : Math.ceil(b / s) * s - s, 'step');
        }
      }, o);
      /* Capture: vor dem Theme-Handler – Prüfung und eindeutige Warenkorbzeile je Leuchte */
      this.form?.addEventListener('submit', (e) => {
        const len = this.state.length;
        if (!this.currentVariant() || len < this.data.min || len > this.data.max) {
          e.preventDefault(); e.stopImmediatePropagation();
          this.message(`Bitte wähle eine Länge zwischen ${this.data.min} und ${this.data.max} cm.`);
          return;
        }
        this.message('');
        this.$('[data-lk-mw-prop-cfg]').value = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      }, { capture: true, signal: this.abort.signal });

      this.initGallery();
      this.update(true);
      this.countInitial();
    }

    disconnectedCallback() { this.abort?.abort(); cancelAnimationFrame(this.raf); delete this.dataset.lkReady; }

    checked(group) { return this.querySelector(`[data-lk-mw-input="${group}"]:checked`)?.value || ''; }
    clamp(v) { return isFinite(v) && v ? Math.min(this.data.max, Math.max(this.data.min, Math.round(v))) : this.data.min; }

    setLength(v, source, keepNumber = false) {
      this.state.length = this.clamp(v);
      if (source !== 'range' && this.range) this.range.value = this.state.length;
      if (!keepNumber && this.number) this.number.value = this.state.length;
      this.update();
    }

    commitNumber() {
      const raw = Number(String(this.number.value).replace(',', '.'));
      const hint = this.$('[data-lk-mw-hint]');
      if (!isFinite(raw) || !raw) { this.number.value = this.state.length; return; }
      const c = this.clamp(raw);
      if (hint) {
        hint.textContent = c === raw ? `Jede Länge von ${this.data.min} bis ${this.data.max} cm möglich.`
          : raw < this.data.min ? `Mindestlänge ${this.data.min} cm – wir haben ${c} cm eingestellt.`
          : raw > this.data.max ? `Maximallänge ${this.data.max} cm – wir haben ${c} cm eingestellt.` : `Auf ${c} cm gerundet.`;
        hint.classList.toggle('is-adjusted', c !== raw);
      }
      this.setLength(c, 'number');
    }

    exec(len, dist = this.state.dist) {
      const parts = [this.state.dim];
      if (this.data.dist) parts.push(dist);
      parts.push(len >= this.data.tierFrom ? this.data.tiers[1] : this.data.tiers[0]);
      return parts.join(' · ');
    }
    findVariant(len, dist) {
      const ex = this.exec(len, dist);
      return this.data.variants.find((v) => v.o[0] === this.state.surface && v.o[1] === this.state.light && v.o[2] === ex);
    }
    currentVariant() { return this.findVariant(this.state.length); }
    perMeter(c) { return this.money.format(c); } /* Cent pro cm = Euro pro Meter */

    update(initial = false) {
      const len = this.state.length;
      const v = this.currentVariant();
      const add = this.$('[name="add"]');
      const label = add?.querySelector('[data-lk-add-text]');
      ['surface', 'light', 'dim'].forEach((k) => { const n = this.$(`[data-lk-mw-label="${k}"]`); if (n) n.textContent = this.state[k]; });
      const distLabel = this.$('[data-lk-mw-label="dist"]');
      if (distLabel) distLabel.textContent = this.state.dist.replace('/', ' + ');
      this.page.dataset.surface = this.state.surface;
      const svg = this.page.querySelector('[data-lk-mw-svg]');
      if (svg) svg.style.setProperty('--lk-mw-light', LIGHT[this.state.light] || LIGHT['3000 K']);

      if (this.range) {
        this.range.style.setProperty('--lk-mw-p', `${((len - this.data.min) / (this.data.max - this.data.min)) * 100}%`);
        this.range.setAttribute('aria-valuetext', `${len} cm`);
      }
      const ll = this.$('[data-lk-mw-length-label]');
      if (ll) ll.textContent = `${len} cm`;
      if (this.number && document.activeElement !== this.number) this.number.value = len;

      if (!v) {
        if (add) add.disabled = true;
        if (label) label.textContent = 'Diese Konfiguration ist nicht verfügbar';
        return;
      }
      if (add) add.disabled = !v.available;
      if (label) label.textContent = v.available ? 'In den Einkaufswagen legen' : 'Derzeit nicht bestellbar';
      this.$('[data-lk-mw-variant]').value = v.id;
      this.$('[data-lk-mw-qty]').value = len;
      this.$('[data-lk-mw-prop-length]').value = `${len} cm`;
      this.$('[data-lk-mw-prop-cm]').value = String(len);
      const skuNode = this.$('[data-lk-mw-sku]'); if (skuNode) skuNode.textContent = v.sku || '–';
      const perM = this.$('[data-lk-mw-per-m]'); if (perM) perM.textContent = this.perMeter(v.price);
      const titleSku = this.page.querySelector('variant-sku'); if (titleSku) titleSku.textContent = v.sku ? `SKU: ${v.sku}` : '';

      const tier = this.$('[data-lk-mw-tier]');
      if (tier) {
        const low = this.findVariant(this.data.min), high = this.findVariant(this.data.tierFrom);
        if (low && high && high.price < low.price) {
          tier.textContent = len < this.data.tierFrom
            ? `Ab ${this.data.tierFrom} cm gilt der günstigere Meterpreis von ${this.perMeter(high.price)}.`
            : `Staffelpreis aktiv: ${this.perMeter(high.price)} statt ${this.perMeter(low.price)} pro Meter – du sparst ${this.money.format(((low.price - high.price) * len) / 100)}.`;
        } else tier.textContent = '';
      }

      const total = v.price * len;
      const ship = this.page.querySelector('lk-product-shipping');
      if (ship) { ship.setAttribute('data-variant-id', String(v.id)); ship.setAttribute('data-price', String(total)); }
      this.renderVisual(len);
      this.targetCents = total;
      if (!initial) this.animateTotal(total, 400);
    }

    animateTotal(target, duration) {
      cancelAnimationFrame(this.raf); clearTimeout(this.safe);
      const from = this.displayCents;
      const set = (c) => { if (this.totalNode) this.totalNode.textContent = this.money.format(Math.round(c) / 100); };
      const finish = () => { cancelAnimationFrame(this.raf); clearTimeout(this.safe); this.displayCents = target; set(target); };
      if (this.reduced.matches || from === target) { finish(); return; }
      let t0;
      const tick = (now) => {
        t0 ??= now;
        const p = Math.min(1, (now - t0) / duration);
        this.displayCents = from + (target - from) * ease(p);
        set(this.displayCents);
        if (p < 1) this.raf = requestAnimationFrame(tick); else finish();
      };
      this.raf = requestAnimationFrame(tick);
      this.safe = setTimeout(finish, duration + 80);
    }

    countInitial() {
      if (this.reduced.matches || !('IntersectionObserver' in window) || !this.totalNode) { this.displayCents = this.targetCents || 0; return; }
      this.displayCents = 0;
      const io = new IntersectionObserver((en) => {
        if (en.some((x) => x.isIntersecting)) { io.disconnect(); if (this.displayCents === 0) this.animateTotal(this.targetCents, 1400); }
      }, { threshold: 0.5 });
      io.observe(this.totalNode);
    }

    renderVisual(len) {
      const svg = this.page.querySelector('[data-lk-mw-svg]');
      if (!svg) return;
      const pendel = this.data.typ === 'pendel';
      const w = 200 + ((len - this.data.min) / (this.data.max - this.data.min)) * 680;
      const xl = 500 - w / 2, xr = 500 + w / 2;
      const cy = pendel ? 560 : 330, slope = w * 0.035;
      const yl = cy + slope, yr = cy - slope;
      const hl = pendel ? 30 : 40, hr = pendel ? 22 : 30;
      const ul = hl * 0.32, ur = hr * 0.32;
      const set = (s, a) => { const el = svg.querySelector(s); if (el) for (const k in a) el.setAttribute(k, a[k]); };
      const toggle = (s, off) => svg.querySelector(s)?.classList.toggle('is-off', off);
      const P = (arr) => arr.map((p) => p.map((n) => n.toFixed(1)).join(',')).join(' ');
      const strip = P([[xl, yl + hl], [xr, yr + hr], [xr, yr + hr + ur], [xl, yl + hl + ul]]);
      set('[data-lk-mw-body]', { points: P([[xl, yl], [xr, yr], [xr, yr + hr], [xl, yl + hl]]) });
      set('[data-lk-mw-cap]', { points: P([[xl - 5, yl + 2], [xl, yl], [xl, yl + hl + ul], [xl - 5, yl + hl + ul - 1]]) });
      set('[data-lk-mw-diffuser]', { points: strip });
      set('[data-lk-mw-diffuser-glow]', { points: strip });
      const up = pendel && this.state.dist !== 'Nur direkt';
      const down = !pendel || this.state.dist !== 'Nur indirekt';
      set('[data-lk-mw-uplight]', { points: P([[xl + 4, yl - 1], [xr - 4, yr - 1], [xr - 4, yr + 2], [xl + 4, yl + 2]]) });
      set('[data-lk-mw-diffuser]', { fill: down ? '#fffaf2' : 'var(--lk-mw-bottom)' });
      toggle('[data-lk-mw-uplight]', !up);
      toggle('[data-lk-mw-diffuser-glow]', !down);
      toggle('[data-lk-mw-up]', !up);
      toggle('[data-lk-mw-down]', !down);
      toggle('[data-lk-mw-floor]', !down);
      set('[data-lk-mw-up]', { cx: 500, cy: pendel ? 260 : 300, rx: w * 0.55 + 120, ry: pendel ? 240 : 120 });
      set('[data-lk-mw-down]', { points: P([[xl + 10, yl + hl], [xr - 10, yr + hr], [xr + 160, 980], [xl - 160, 980]]) });
      set('[data-lk-mw-floor]', { rx: w * 0.5 + 80 });
      if (pendel) {
        const k = (2 * slope) / w;
        const ax = xl + w * 0.14, bx = xr - w * 0.14;
        set('[data-lk-mw-cable-a]', { x1: ax, y1: 0, x2: ax, y2: yl - (ax - xl) * k });
        set('[data-lk-mw-cable-b]', { x1: bx, y1: 0, x2: bx, y2: yl - (bx - xl) * k });
      }
      const dl = svg.querySelector('[data-lk-mw-dim-label]'); if (dl) dl.textContent = `${len} cm`;
      const t = svg.querySelector('[data-lk-mw-svg-title]');
      if (t) t.textContent = `${this.data.title}, ${this.state.surface}, ${this.state.light}${this.state.dist ? ', ' + this.state.dist : ''}, ${len} cm`;
    }

    initGallery() {
      const g = this.page.querySelector('[data-lk-mw-gallery]');
      if (!g) return;
      const track = g.querySelector('[data-lk-mw-gallery-track]');
      const slides = track ? Array.from(track.children) : [];
      const thumbs = Array.from(g.querySelectorAll('[data-lk-mw-gallery-thumb]'));
      const counter = g.querySelector('[data-lk-mw-gallery-counter]');
      let i = 0;
      const show = (n) => {
        if (!slides.length) return;
        i = (n + slides.length) % slides.length;
        track.style.transform = `translateX(-${i * 100}%)`;
        if (counter) counter.textContent = `${i + 1} / ${slides.length}`;
        thumbs.forEach((t, k) => { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      };
      g.querySelector('[data-lk-mw-gallery-prev]')?.addEventListener('click', () => show(i - 1));
      g.querySelector('[data-lk-mw-gallery-next]')?.addEventListener('click', () => show(i + 1));
      thumbs.forEach((t) => t.addEventListener('click', () => show(Number(t.dataset.lkMwGalleryThumb))));
      let x0 = null;
      track?.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
      track?.addEventListener('pointerup', (e) => { if (x0 === null) return; const d = e.clientX - x0; x0 = null; if (Math.abs(d) > 45) show(i + (d < 0 ? 1 : -1)); });
    }

    message(text) {
      const m = this.$('[data-lk-mw-message]');
      if (!m) return;
      m.textContent = text;
      m.hidden = !text;
    }
  }
  customElements.define('lk-meterware', LkMeterware);
})();